export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/bt.6ba8942c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};